import { Outlet, createFileRoute, linkOptions } from '@tanstack/react-router'
import { t } from 'i18next'
import {
  Building2,
  FileCheck,
  FileWarning,
  Layers2,
  SearchIcon,
  Shield,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Kbd, KbdGroup } from '@shadcn/kbd'

import { globalSearchAtom } from '@/stores/global-search.atom'
import { store } from '@/stores/store'

import SectionLayout from '../-components/section-layout/section-layout'

export const Route = createFileRoute('/app/data')({
  component: RouteComponent,
})

const openGlobalSearch = () =>
  store.set(globalSearchAtom, (prev) => ({ ...prev, open: true }))

const sidebarProps = {
  links: [
    {
      Icon: Layers2,
      label: t('data.groups.title'),
      link: linkOptions({ to: '/app/data/groups' }),
      activeLink: '/app/data/groups',
    },
    {
      Icon: Building2,
      label: t('data.companies.title'),
      link: linkOptions({ to: '/app/data/companies' }),
      activeLink: '/app/data/companies',
    },
    {
      Icon: FileCheck,
      label: t('data.policies.title'),
      link: linkOptions({ to: '/app/data/policies' }),
      activeLink: '/app/data/policies',
    },
    {
      Icon: Shield,
      label: t('data.coverages.title'),
      link: linkOptions({ to: '/app/data/coverages' }),
      activeLink: '/app/data/coverages',
    },
    {
      Icon: FileWarning,
      label: t('data.insistences.title'),
      link: linkOptions({ to: '/app/data/insistences' }),
      activeLink: '/app/data/insistences',
    },
  ],
  children: (
    <div
      className="flex w-full cursor-pointer items-center gap-3 rounded-md border p-2 px-3 group-data-[state=closed]:justify-center group-data-[state=closed]:border-0 group-data-[state=closed]:px-0"
      tabIndex={2}
      onClick={openGlobalSearch}
      onKeyDown={(e) => {
        if (e.key === 'Enter') openGlobalSearch()
      }}
    >
      <SearchIcon className="text-text-tertiary-600 size-5 shrink-0" />
      <span className="text-text-tertiary-600 text-sm font-semibold group-data-[state=closed]:hidden">
        {t('data.search')}
      </span>
      <KbdGroup className="group-data-[state=closed]:hidden">
        <Kbd>Ctrl + K</Kbd>
      </KbdGroup>
    </div>
  ),
}

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <SectionLayout title={t('data.title')} sidebarProps={sidebarProps}>
      <Outlet />
    </SectionLayout>
  )
}
